import { useContext } from 'react'
import { useCallback } from 'react'

import AppContext from '@/common/context/app.context'

const useUserPermissions = () => {
  const { info } = useContext(AppContext)

  const getUserPermissions = useCallback(
    storeId => {
      return info?.userInfo?.stores?.find(store => store?.id === storeId)?.group?.permissions
    },
    [info]
  )

  const hasPermission = useCallback(
    (codename, storeId = info.selectedStore?.id) => {
      return !!getUserPermissions(storeId)?.find(permission => permission.codename === codename)
    },
    [info, getUserPermissions]
  )

  const isOwner = () => {
    return info?.userInfo?.is_owner
  }

  return {
    getUserPermissions,
    hasPermission,
    isOwner,
  }
}

export default useUserPermissions
